module.exports = __webpack_public_path__ + "img/switzerland-tuberculosis-female.bf534b6a.png";